import { ThemeProvider } from "@mui/material"

import Theme from "../assets/Theme"
import Navbar from "../components/Navbar"

const PageLayout = ({ children, hero }) => (
    <>
        <ThemeProvider theme={Theme.Dark}>
            <Navbar />
            {hero}
        </ThemeProvider>
        {children}
    </>
)

export default PageLayout
